export default __webpack_public_path__ + "static/5-452668188965d7b951e18c27d33e3c8e.jpg";